import { API_ENDPOINTS } from "../constants/endpoints";
import { MigrateUserRequest, SuperAdminGenericResponse, CancellationsResponse } from "../types/super-admin";
import { post, get } from "../utils/api.utils";

class SuperAdminService {
  public static async migrateUser(data: MigrateUserRequest): Promise<SuperAdminGenericResponse> {
    try {
        const response = await post<SuperAdminGenericResponse>(
            API_ENDPOINTS.SUPER_ADMIN.MIGRATE_USER,
                data
            );
        return response;
    } catch (error) {
      throw error;
    }
  }

  public static async getCancellations(): Promise<SuperAdminGenericResponse<CancellationsResponse>> {
    try {
      const response = await get<SuperAdminGenericResponse<CancellationsResponse>>(
        API_ENDPOINTS.SUPER_ADMIN.GET_CANCELLATIONS
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default SuperAdminService;

